import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useReview from 'hooks/products/useReview';
import { useViewportWidth } from '@xstyled/styled-components';
import Modal from '@/UI/Modal';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { SectionTitle } from '@/UI/Primitives/Headings';
import Input from '@/UI/Form/Input';
import Textarea from '@/UI/Form/Textarea';
import PrimaryButton from '@/UI/Button/Variants/Primary';
import RatingScale from '@/UI/Ratings/RatingScale';
import Spinner from '@/UI/Loader/Spinner';

export default function RatingModal({ product, isShown, toggle }) {
  const viewportWidth = useViewportWidth();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors }
  } = useForm();

  const [rating, setRating] = useState(null);
  const [error, setError] = useState(null);

  const { onSubmit, data, loading } = useReview(rating, product?.sku);

  // Set error when no rating added
  useEffect(() => {
    if (isSubmitting && !rating) {
      setError('Hinnang on kohustuslik');
    } else if (rating) {
      setError(null);
    }
  }, [isSubmitting, rating]);

  // Close modal on successful submit & show toast
  useEffect(() => {
    if (data) {
      newRatingAddedToast({ isDesktop: viewportWidth >= 1024 });
      toggle();
    }
  }, [data]);

  const modalContent = (
    <FlexBox
      as="form"
      dir="column"
      align="center"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionTitle
        textAlign="center"
        fontSize={{ _: 'large', sm_tablet: 'xlarge' }}
        pt="0.75rem"
        pb="2rem"
      >
        {product?.name}
      </SectionTitle>
      <SectionTitle fontSize={{ _: 'small', sm_tablet: 'medium' }}>
        Hinnang tootele:
      </SectionTitle>
      <RatingScale rating={rating} setRating={setRating} error={error} />
      <FlexBox
        dir="column"
        spaceY="1.5rem"
        alignSelf="flex-start"
        w="100%"
        mt="1.75rem"
      >
        <Input
          {...register('reviewer', { required: 'Kohustuslik väli' })}
          placeholder="Nimi"
          error={errors?.reviewer}
          w={{ _: '100%', tablet: '350px' }}
          borderRadius="7px"
        />
        <Textarea
          {...register('comment', { required: 'Kohustuslik väli' })}
          placeholder="Kommentaar"
          error={errors.comment}
          w="100%"
          borderWidth="1px"
        />
      </FlexBox>
      <PrimaryButton
        type="submit"
        p="0.5rem"
        w={{ _: '220px', desktop: '40%' }}
        mt="2.5rem"
      >
        {isSubmitting || loading ? <Spinner /> : 'Lisa kommentaar'}
      </PrimaryButton>
    </FlexBox>
  );

  return (
    <Modal
      isShown={isShown}
      hide={toggle}
      content={modalContent}
      width={{ _: '90vw', tablet: '500px', desktop: '790px' }}
      p={{ _: '2.5rem 1rem', sm_tablet: '3rem 2rem', desktop: '3rem 6rem' }}
    />
  );
}
